import React from "react";
import { Box, Button } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Langs from "../../../../../app/lang/langs";
import { ORANGE } from "../constants";

const barSx = {
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  display: "flex",
  gap: 1.5,
  px: 2.5,
  py: 2,
  bgcolor: "rgba(255,255,255,0.95)",
  backdropFilter: "blur(16px)",
  borderTop: "1px solid rgba(0,0,0,0.06)",
  zIndex: 1400,
};

const cancelBtnSx = {
  borderRadius: 999,
  minHeight: 48,
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.9rem",
  borderColor: "rgba(0,0,0,0.15)",
  color: "text.primary",
  "&:hover": { borderColor: "rgba(0,0,0,0.3)" },
  "&:active": { transform: "scale(0.97)" },
};

const deleteBtnSx = {
  borderRadius: 999,
  minHeight: 48,
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.9rem",
  borderColor: "error.main",
  color: "error.main",
  "&:hover": { bgcolor: "error.main", color: "white", borderColor: "error.main" },
  "&:active": { transform: "scale(0.97)" },
};

const primaryBtnSx = {
  borderRadius: 999,
  minHeight: 48,
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.9rem",
  bgcolor: ORANGE,
  boxShadow: "0 4px 14px rgba(255,144,21,0.4)",
  "&:hover": { bgcolor: "#e6820d", boxShadow: "0 6px 20px rgba(255,144,21,0.5)" },
  "&:active": { transform: "scale(0.97)" },
};

export default function BottomBar({ showEditButtons, showAddButtons, onHide, onSave, onAdd, onDelete }) {
  if (showEditButtons) {
    return (
      <Box sx={barSx}>
        <Button variant="outlined" fullWidth onClick={onHide} sx={cancelBtnSx}>
          <Langs str="CANCEL" />
        </Button>
        <Button variant="outlined" fullWidth onClick={onDelete} startIcon={<DeleteOutlineIcon />} sx={deleteBtnSx}>
          <Langs str="DELETE" />
        </Button>
        <Button variant="contained" fullWidth onClick={onSave} sx={primaryBtnSx}>
          <Langs str="SAVE" />
        </Button>
      </Box>
    );
  }

  if (showAddButtons) {
    return (
      <Box sx={barSx}>
        <Button variant="outlined" fullWidth onClick={onHide} sx={cancelBtnSx}>
          <Langs str="CANCEL" />
        </Button>
        <Button variant="contained" fullWidth onClick={onAdd} sx={primaryBtnSx}>
          <Langs str="ADD" />
        </Button>
      </Box>
    );
  }

  return null;
}
